module.exports = __webpack_public_path__ + "static/media/tidings.e3346212.PNG";